import styles from './skeleton.module.sass';
import cn from 'classnames';
import { DetailedHTMLProps, HtmlHTMLAttributes } from 'react';
import { pxToRem } from '@intigral/utils/lib/helpers/pxToRem';

interface SkeletonProps extends DetailedHTMLProps<HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    variant?: 'text' | 'rectangular' | 'circle' | 'rounded';
    width?: number | string;
    height?: number | string;
    animation?: boolean;
    absolute?: boolean;
    alignment?: 'center' | 'end';
}

export const Skeleton = ({
    variant = 'rounded',
    width,
    height,
    animation = true,
    absolute = false,
    alignment,
    ...props
}: SkeletonProps) => {
    // Convert width and height to REM if they are provided
    const style = {
        width: typeof width === 'number' ? pxToRem(width) : width,
        height: typeof height === 'number' ? pxToRem(height) : height,
    };
    return (
        <div
            className={cn(
                variant && styles[variant],
                animation && styles.animate,
                absolute && styles.absolute,
                alignment && styles[alignment],
                styles.skeleton
            )}
            style={style}
            {...props}
        ></div>
    );
};

export const GridSkeleton = () => {
    return (
        <div className={styles['grid-wrapper']}>
            <div className={styles.grid}>
                {Array.from(Array(25).keys()).map((el) => (
                    <Skeleton key={el} />
                ))}
            </div>
        </div>
    );
};
